/* eslint-disable indent */
import React from "react";
import { Table } from "antd";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { getOrderPageNumber } from "store/slices/order.slice";
import "./list.scss";
import {
  IPerlickTrunkDetailList,
  IPerlickTrunkList,
  PerlickCHOrderList,
} from "interfaces/ClientInterface/PerlickClientInterface/ICHOrder";
import { IPerlickCHOrderList } from "interfaces/ClientInterface/PerlickClientInterface/IOrder";
import { getCHOrderPageNumber, getCHOpenStatusModel } from "store/slices/chorder.slice";
import { getStatusValue } from "utils";

export default function List(props: PerlickCHOrderList) {
  const dispatch = useAppDispatch();
  const orderPage = useAppSelector((state) => state.order.OrderActivePageNumber);
  const {
    columns,
    data,
    pagination,
    paginationPosition = "bottomLeft",
    classSelector,
    isLoading,
    rowSelection,
    sortingColumn,
    setSortingColumn,
    setSortSize,
    setPageIndex,
    NumberOfRecords,
    setLoadPage,
  } = props;
  return (
    <>
      <Table
        dataSource={data}
        columns={columns.map((column) => ({
          ...column,
          onHeaderCell: () => {
            return {
              onClick: () => {
                setSortingColumn({
                  sortByColumnName: column.key,
                  sortType: sortingColumn.sortType === "ASC" ? "DESC" : "ASC",
                });
              },
            };
          },
        }))}
        pagination={
          pagination
            ? {
                onChange: (page, pageSize) => {
                  dispatch(getOrderPageNumber(page));
                  setPageIndex?.(page);
                  setSortSize?.(pageSize);
                  if (setLoadPage) {
                    setLoadPage(true);
                  }
                },
                showSizeChanger: true,
                current: orderPage,
                position: [paginationPosition],
                total: NumberOfRecords,
              }
            : false
        }
        scroll={{ x: "max-content" }}
        data-test-selector="tblList"
        className={`your-table-class ${classSelector}`}
        loading={isLoading}
        rowSelection={rowSelection}
        rowKey={(record) => record?.sysid}
      />
    </>
  );
}

export function TrunkList(props: IPerlickTrunkList) {
  const {
    showClass,
    columns,
    data,
    pagination,
    paginationPosition = "bottomRight",
    classSelector,
    isLoading,
    rowSelection,
    sortingColumn,
    setSortingColumn,
    setSortSize,
    setPageIndex,
    NumberOfRecords,
  } = props;
  return (
    <>
      <Table
        dataSource={data}
        columns={columns.map((column) => ({
          ...column,
          onHeaderCell: () => {
            return {
              onClick: () => {
                setSortingColumn({
                  sortByColumnName: column.key,
                  sortType: sortingColumn.sortType === "ASC" ? "DESC" : "ASC",
                });
              },
            };
          },
        }))}
        pagination={
          pagination
            ? {
                onChange: (page, pageSize) => {
                  setPageIndex?.(page);
                  setSortSize?.(pageSize);
                },
                position: [paginationPosition],
                total: NumberOfRecords,
              }
            : false
        }
        scroll={{ x: "max-content" }}
        data-test-selector="tblList"
        className={showClass ? classSelector : ""}
        loading={isLoading}
        rowSelection={rowSelection}
      />
    </>
  );
}

export function TrunkDetailList(props: IPerlickTrunkDetailList) {
  const {
    showClass,
    columns,
    data,
    classSelector,
    isLoading,
    rowSelection,
    sortingColumn,
    setSortingColumn,
    setSortSize,
    setPageIndex,
    NumberOfRecords,
    trunkNumber,
  } = props;
  return (
    <>
      {trunkNumber && (
        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            backgroundColor: "#f5f5f5",
            padding: "8px 0",
            borderTop: "1px solid #f0f0f0",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          Line Data for Trunk Housing {trunkNumber}
        </div>
      )}
      <Table
        dataSource={data}
        columns={columns.map((column) => ({
          ...column,
          onHeaderCell: () => {
            return {
              onClick: () => {
                setSortingColumn({
                  sortByColumnName: column.key,
                  sortType: sortingColumn.sortType === "ASC" ? "DESC" : "ASC",
                });
              },
            };
          },
        }))}
        pagination={{
          onChange: (page, pageSize) => {
            setPageIndex?.(page);
            setSortSize?.(pageSize);
          },

          total: NumberOfRecords,
        }}
        scroll={{ x: "max-content" }}
        data-test-selector="tblList"
        className={showClass ? classSelector : ""}
        loading={isLoading}
        rowSelection={rowSelection}
      />
    </>
  );
}

export function CHList(props: IPerlickCHOrderList) {
  const dispatch = useAppDispatch();
  const orderPage = useAppSelector((state) => state.chorder.OrderActivePageNumber);
  const {
    columns,
    data,
    pagination,
    paginationPosition = "bottomLeft",
    classSelector,
    isLoading,
    rowSelection,
    sortingColumn,
    setSortingColumn,
    setSortSize,
    setPageIndex,
    NumberOfRecords,
    setLoadPage,
  } = props;
  return (
    <>
      <Table
        dataSource={data}
        columns={columns.map((column) => ({
          ...column,
          onHeaderCell: () => {
            return {
              onClick: () => {
                setSortingColumn({
                  sortByColumnName: column.key,
                  sortType: sortingColumn.sortType === "ASC" ? "DESC" : "ASC",
                });
              },
            };
          },
        }))}
        pagination={
          pagination
            ? {
                onChange: (page, pageSize) => {
                  dispatch(getCHOrderPageNumber(page));
                  setPageIndex?.(page);
                  setSortSize?.(pageSize);
                  if (setLoadPage) {
                    setLoadPage(true);
                  }
                },
                showSizeChanger: true,
                current: orderPage,
                position: [paginationPosition],
                total: NumberOfRecords,
              }
            : false
        }
        scroll={{ x: "max-content" }}
        data-test-selector="tblList"
        className={`your-table-class ${classSelector}`}
        loading={isLoading}
        rowSelection={rowSelection}
        rowKey={(record) => record.ordno}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onRow={(record: any) => ({
          onClick: () => {
            dispatch(
              getCHOpenStatusModel(
                getStatusValue(record.Calculated_Status ? record.Calculated_Status : "")
              )
            );
          },
        })}
      />
    </>
  );
}
